export class SignResult {
  public isCancelled: boolean = false;
  public isSucceed: boolean = false;
  public isError: boolean = false;
  public result: any;
  public error: any;
  public errorSource: string = '';

  constructor(prms?: {}) {
    this.init(prms);
  }
  private init(prms?: {}): void {
    if (prms) {
      Object.keys(this).forEach(k => {
        if (k in prms) {
          this[k] = prms[k];
        }
      });
    }
  }
}
